/* eslint-disable */
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Button,
  Form,
  Dropdown,
} from "antd";
import React, { useEffect, useRef, useState,forwardRef, useImperativeHandle } from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  VerticalAlignBottomOutlined,
  MenuOutlined,
  EditOutlined,
  PlusOutlined,
  HistoryOutlined,
  AccountBookOutlined 
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import VendorModal from "./component/NewModal";
import UpdateModal from "./component/UpdateModal";
import EditHistory from "@/views/AccountPayable/VendorMWorker/EditHistory";
import PaymentModal from "./component/PaymentModal";
const Vendors = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [modalVisible, setModalVisible] = useState(false);
   const [updateModalVisible, setUpdateMlVisible] = useState(false);
   const [currentRecord, setCurrentRecord] = useState(null);
  const [vendorTypeOptions, setVendorTypeOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const editHistoryModalRef = useRef(null);
  const PaymentModalRef = useRef(null)
  // 处理选项变化
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(
      initColumns.map((item) => ({
        ...item,
        hidden: !checkedValues.includes(item.dataIndex),
      }))
    );
  };

  const showModal = () => {
 
    setModalVisible(true);
  };
  const handleCloseModal = () => {
    setModalVisible(false);
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        {/* 使用 Space 的 direction="vertical" 来让复选框垂直排列 */}
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );
  const content2 = <a>Export to CSV</a>;

  // table
  const initTableHead = {
    role: null,
    module: null,
    firstName: null,
    dateTimeRequest: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "propId",
      hidden: false,
      align: "center",
      width: 80,
      render: (text, record, index) => (
        (commonFn.btnAuthorityFlag("Updated") ||
          commonFn.btnAuthorityFlag('EditHistory')||
          commonFn.btnAuthorityFlag('VendorPayments')) && (<Dropdown
          menu={{
            items: [
              commonFn.btnAuthorityFlag('Updated') && {
                key: "update",
                icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "16px" }} />,
                label: <div>Edit Vendor</div>,
              },
              commonFn.btnAuthorityFlag('EditHistory') && {
                key: "EditHistory",
                icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "16px" }} />,
                label: <div>Edit History</div>,
              },
                commonFn.btnAuthorityFlag('VendorPayments') && {
                key: "VendorPayments",
                icon: <AccountBookOutlined style={{ color: "#00c0ef", fontSize: "16px" }}/>,
                label: <div>Vendor By Payments</div>,
              },
            ].filter(Boolean),
            onClick: (e) => handleMenuClick(e, record),
          }} 
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>
        )) || null
    },
    // {
    //   title: "Vendor Id",
    //   dataIndex: "vendorId",
    //   titleType: "Input",
    //   width: 80,
    //   onChange: (e) => tableFilterFn(e, "vendorId"),
    // },
{
  title: "Vendor Name",
  dataIndex: "name",
  titleType: "Input",
  width: 180,
  align:"left",
  render: (text, record) => (
    <span>
      {record.name}
      <br />
      {record.vendid}
       <br />
      {record.vendorId}
    </span>
  ),
  onChange: (e) => tableFilterFn(e, "name"),
},
    {
      title: "Vendor Type",
      dataIndex: "vendorType",
      titleType: "Select",
      width: 200,
      selectOptions: vendorTypeOptions,
      onChange: (e) => tableFilterFn(e, 'vendorType', 'Select'),
    },
    {
      title: "Mailing Address City",
      dataIndex: "mailingAddressCity",
      titleType: "Input",
       width: 230,
      onChange: (e) => tableFilterFn(e, "mailingAddressCity"),
    },
    // {
    //   title: "State",
    //   dataIndex: "state",
    //   titleType: "Select",
    //   width: 120,
    //   selectOptions: stateOptions,
    //   onChange: (e) => tableFilterFn(e, 'state', 'Select'),
    // },
    {
      title: "Contact Name",
      dataIndex: "nameKey",
      titleType: "Input",
      width: 100,
      onChange: (e) => tableFilterFn(e, "nameKey"),
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "phoneNumber"),
    },
    {
      title: "Email",
      dataIndex: "email",
      titleType: "Input",
       width: 100,
      onChange: (e) => tableFilterFn(e, "email"),
    },
        {
      title: "Tax ID",
      dataIndex: "fedId",
      titleType: "Input",
       width: 100,
      onChange: (e) => tableFilterFn(e, "fedId"),
    },
       {
      title: "Very Last Pay Date",
      dataIndex: "postedDate",
      titleType: "",
      width: 120,
      render: (text =>  text && moment(text).format("MM/DD/YYYY"))
    },
    {
      title: "Status",
      dataIndex: "status",
      titleType: "Select",
      width: 100,
      selectOptions: [
        {value: 'A', label: 'Active'},
        {value: 'I', label: 'Inactive'},
      ],
      onChange: (e) => tableFilterFn(e, "status", 'Select'),
      render: (text) => {
        return text === "A" ? 'Active' : "Inactive"
      }
    },
    // {
    //   title: "Last Date",
    //   dataIndex: "lastIssueCheck",
    //   titleType: "",
    //   width: 120,
    //   render: (text =>  text && moment(text).format("MM/DD/YYYY"))
    // },
  ];

  const handleMenuClick = async (e, record) => {
    if (e.key === "update") {
      console.log(record);
      setUpdateMlVisible(true)
        setCurrentRecord(record);
    }
    if (e.key === "EditHistory") {
      editHistoryModalRef.current?.openModal({
        modalName: 'Edit History',
        type: 'vendor',
        id: record?.vendorId
      })
    }
     if (e.key === "VendorPayments") {
       PaymentModalRef.current?.openModal(record);
    }
  };
  // 获取列表数据
const getTableListFn = async (
  current,
  pageSize,
  head = tableHead  
) => {
  setTableLoading(true);

  const params = {
    page: current || pagination.current,
    count: pageSize || pagination.pageSize,
    ...head,
  };

  const response = await http.get(api.getVendorList, { params });

  if (response?.code !== "1") {
    commonFn.modalFailedFn(response);
    setTableLoading(false);
    return;
  }

  const list = (response.data.list || []).map((item, index) => ({
    ...item,
    "#": (params.page - 1) * params.count + index + 1,
  }));

  setTableList(list);
  setPagination((prev) => ({
    ...prev,
    total: response.data.total || 0,
    current: params.page,
    pageSize: params.count,
  }));

  setTableLoading(false);
};

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

 
const handleRoleUpdateSuccess = () => {
  getTableListFn(pagination.current, pagination.pageSize);
};
 useEffect(() => {
  initColunmsFn();
  getTableListFn(pagination.current, pagination.pageSize, tableHead);
}, [refreshKey]);


  const getDictionaryFn = async(key, fn, obj) => {
    const response = await http.get(api.getVendorType, { params: {flag: key} });
    fn((response || []).map(item => ({
      value: item[obj.value],
      label: item[obj.label],
    })))
  }

  useEffect(() => {
    getDictionaryFn('status', setVendorTypeOptions, {value: 'typeCode', label: 'typeName'})
    getDictionaryFn('state', setStateOptions, {value: 'stateM', label: 'stateName'})
  }, []);

  
  useEffect(() => {
    if(vendorTypeOptions?.length && stateOptions?.length){
      setColumns(initColumns);
    }
  }, [vendorTypeOptions, stateOptions]);
  useImperativeHandle(ref, () => ({
    refresh: () => {
      // 刷新表格数据
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    }
  }));
  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          {" "}
          {commonFn.btnAuthorityFlag('New') &&  <Button className="btnNew" onClick={showModal}>
              <PlusOutlined />
            New
          </Button>}
        </div>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
            {commonFn.btnAuthorityFlag('Download') && <Radio.Button value="c">
              <Popover content={content2} title="" trigger="click">
                <VerticalAlignBottomOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>}
          </Radio.Group>
        </div>
      </Flex>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="340px"
        tableCss="maintenanceTable"
      />

      {/* 新增modal */}
      <VendorModal open={modalVisible} onCancel={handleCloseModal} onSuccess={handleRoleUpdateSuccess} />
      {/* 修改 */}
      <UpdateModal  open={updateModalVisible}  onCancel={() => setUpdateMlVisible(false)}   record={currentRecord} onSuccess={handleRoleUpdateSuccess}/>
      <EditHistory ref={editHistoryModalRef} />
      <PaymentModal ref={PaymentModalRef} />
    </div>
  );
});

export default Vendors;